"use client";

import { c as _c } from "react/compiler-runtime";
import LogoDark from "assets/icons/logo-erecruiter-symbol-dark.svg";
import LogoWhite from "assets/icons/logo-erecruiter-symbol-white.svg";
import s from "ui/Footer/styles.module.css";
import { TypoTextSmall } from "ui/Typo";
import { cn } from "utils/helpers/cn";
import useHighContrast from "utils/hooks/useHighContrast";
const erecruiterUrl = "https://erecruiter.pl/?utm_source=application-form&utm_medium=link&utm_campaign=formularz-aplikacyjny-erecruiter";
function Footer() {
  const $ = _c(6);
  const [isHighContrast] = useHighContrast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn(s.footer, "mb-n8 flex items-center justify-center gap-n1");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isHighContrast) {
    t1 = isHighContrast ? <LogoDark /> : <LogoWhite />;
    $[1] = isHighContrast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TypoTextSmall className="text-[#0F3741] text-[10px] dark:text-white">powered by eRecruiter</TypoTextSmall>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <footer className={t0}><a href={erecruiterUrl} target="_blank" rel="noreferrer noopener" className="flex items-center justify-center gap-n1" data-test-id="footer-link">{t1}{t2}</a></footer>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default Footer;